import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21a20fc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-info" }
const _hoisted_2 = { class: "order-title" }
const _hoisted_3 = { class: "order-address mb_10" }
const _hoisted_4 = { class: "order-item flex-ter" }
const _hoisted_5 = { class: "order-item flex-ter" }
const _hoisted_6 = {
  key: 0,
  style: {"display":"flex","width":"400px"}
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { style: {"padding":"16px"} }
const _hoisted_10 = { style: {"display":"flex"} }
const _hoisted_11 = { style: {"width":"60%"} }
const _hoisted_12 = { style: {"flex-grow":"2"} }
const _hoisted_13 = { style: {"display":"flex"} }
const _hoisted_14 = { style: {"width":"60%"} }
const _hoisted_15 = { style: {"flex-grow":"2"} }
const _hoisted_16 = { style: {"display":"flex"} }
const _hoisted_17 = { style: {"width":"60%"} }
const _hoisted_18 = { style: {"flex-grow":"2"} }
const _hoisted_19 = { style: {"display":"flex"} }
const _hoisted_20 = { style: {"width":"60%"} }
const _hoisted_21 = { style: {"flex-grow":"2"} }
const _hoisted_22 = { style: {"color":"#0586FE","cursor":"pointer"} }
const _hoisted_23 = { class: "order-title" }
const _hoisted_24 = { class: "order-address mb_10" }
const _hoisted_25 = { class: "order-item flex-ter" }
const _hoisted_26 = { class: "order-title" }
const _hoisted_27 = { class: "mb_10" }
const _hoisted_28 = { style: {"margin-bottom":"10px"} }
const _hoisted_29 = { class: "deliver-addition-title" }
const _hoisted_30 = { class: "price" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("， ")
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 2 }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("， ")
const _hoisted_36 = { key: 3 }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("， ")
const _hoisted_38 = { class: "order-title-action" }
const _hoisted_39 = { class: "order-title" }
const _hoisted_40 = { class: "mb_10" }
const _hoisted_41 = { style: {"width":"200px"} }
const _hoisted_42 = { class: "line--2" }
const _hoisted_43 = {
  key: 0,
  class: "total-num-style"
}
const _hoisted_44 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { class: "order-title" }
const _hoisted_57 = { class: "mb_10" }

import { t } from '@/plugins/i18n'
import { ref, onActivated, computed, watch, reactive, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
import { isJA } from '@/store'
import STable from '@/components/Table/index.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import UploadFileReplace from '@/components/common/UploadFilePDFReplace.vue'
import BoxInfoDialog from '../components/boxInfoDialog.vue'
import { productColumns, AmazonColumns, thirdWarehouseTypeDict, boxDetailColumns, boxColumns } from './data'
import { getDeliveryInfo, getTrack, getBoxInfo, editBarCode } from '@/apis/inShipping'
import { deliveryTypeDict, deliveryStatusDict } from '../ShippingList/data'
import TrackDialog from '../ShippingList/TrackDialog/index.vue'
import axios from 'axios'
import { useStore } from 'vuex'
import { exportFileDownload } from '@/util/useExport'
import { getAreaTxt, getCityTxt, getJapanTime } from '@/util/common'
import { getCustomerShop } from '@/apis/order'
import { round } from 'lodash'
import FeeDetail from './components/FeeDetail.vue'
import useUserConfig, { ENUM_CONFIG_CODE } from '@/util/useUserConfig'
import { responseReceiptData, ASK_ENUM } from '@/views/setup/components/utils'
import ModalFundFlowContent from '@/views/fund/FundList/components/ModalFundFlowContent.vue'
import { showCurrentUnit } from '@/util/useYan'
import { COUNTRY } from '@/global'
import { tCurrency } from '@/views/shopcart/country'

interface Column {
  label?: string,
  prop?: string,
  align?: string,
  width?: number,
  slotName?: string
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const [getSignUpValue] = useUserConfig(ENUM_CONFIG_CODE.RETAIL_BOOK)

const route = useRoute()
onActivated(() => {
  getOrder()
})
const isAmazon = ref()

onMounted(() => {
  getCustomerShop().then((res: any) => {
    if (res.success) {
      isAmazon.value = res.data.customerShopPlatform === 4 && res.data.customerShopAuthStatus
    }
  })
})

const orderInfo: any = ref({})
const logisticsDetailList = ref()
const taskDetailList = ref()
const clearanceAddressList = ref()
const shippingAddressList = ref()
const boxInfoList = ref([])
const totalGoodsPrice = ref(0) // 商品总额
// 商品内容需要新增一行放合计
const getTaskDetailList = () => {
  if (!taskDetailList.value?.length || !isJA()) {
    return taskDetailList.value
  }
  //   总的计划发货数量
  const allClientDeliveryNums = taskDetailList.value?.reduce((pre, cur) => {
    return pre + (Number(cur.deliveryNums ?? 0))
  }, 0)
  //   总的实际发货数量
  const allClientRealDeliveryNums = taskDetailList.value?.reduce((pre, cur) => {
    return pre + (Number(cur.realDeliveryNums ?? 0))
  }, 0)
  //   总的小计
  const allClientAllPrice = round(taskDetailList.value?.reduce((pre, cur) => {
    return pre + round(((cur?.realDeliveryNums ?? 0) * (cur?.productPrice ?? 0)) * 100) / 100
  }, 0) * 100) / 100
  //   clientIsTotal前端自定义字段，判断是否是最后一行合计
  return taskDetailList.value.concat([{ clientIsTotal: true, allClientDeliveryNums, allClientRealDeliveryNums, allClientAllPrice }])
}
/** 给合计的那行添加class */
const getRowClassName = ({ row }) => {
  if (row.clientIsTotal && isJA()) {
    return 'total-num-row-class'
  }
  return ''
}

const getOrder = () => {
  getDeliveryInfo({
    deliveryTaskCode: route.query.deliveryTaskCode
  }).then(res => {
    orderInfo.value = res.data
    console.log(orderInfo.value.shippingType)
    logisticsDetailList.value = res.data?.logisticsDetailList
    boxInfoList.value = []
    res.data && res.data.logisticsDetailList && (res.data.logisticsDetailList).forEach((v: any) => {
      boxInfoList.value = boxInfoList.value.concat(v.deliveryBoxList)
    })
    console.log(res.data)
    taskDetailList.value = res.data?.taskDetailList;
    (res.data?.deliveryTaskAddressList || []).forEach((e: { addressType: number }) => {
      if (e.addressType === 0) {
        shippingAddressList.value = e
      } else if (e.addressType === 2) {
        clearanceAddressList.value = e
      }
    })
    totalGoodsPrice.value = 0
    res.data.taskDetailList.forEach((item: any) => {
      totalGoodsPrice.value += item.productPrice * item.realDeliveryNums
    })
  })
}

const trackVisible = ref(false)
const rowItem: any = ref({})
const showTrack = (row: any) => {
  row.trackLoading = true
  getTrack({
    deliveryTaskCode: route.query.deliveryTaskCode,
    logisticsCode: row.logisticsCode
  }).then((res: any) => {
    rowItem.value = res.data
  }).finally(() => { row.trackLoading = false; trackVisible.value = true })
}

const objectSpanMethod = ({
  row,
  column,
  rowIndex,
  columnIndex
}: any) => {
  if (columnIndex === 3 || columnIndex === 4) {
    if (rowIndex === 0) {
      return {
        rowspan: logisticsDetailList.value.length,
        colspan: 1
      }
    } else {
      return {
        rowspan: 0,
        colspan: 0
      }
    }
  }
}

const store = useStore()
const exportList = () => {
  axios({
    method: 'POST',
    url: process.env.VUE_APP_URL + '/wms/delivery/task/customerDownloadPackingList',
    responseType: 'blob',
    headers: {
      'X-AuthShopId': store.getters.curShop,
      'X-AuthToken': store.getters.token,
      'X-GRAY-TAG': process.env.VUE_APP_X_GRAY_TAG || '',
      'X-Platform': 'PC',
      'X-Appname': 'ckb-client-pc'
    },
    data: {
      deliveryTaskCodeList: [route.query.deliveryTaskCode]
    }
  }).then(res => {
    exportFileDownload(res, { name: t('装箱清单') })
  })
}

const detailVisible = ref(false)
const boxDetail = ref()
const checkDetail = () => {
  getBoxInfo({
    deliveryTaskCode: route.query.deliveryTaskCode
  }).then((res: any) => {
    detailVisible.value = true
    let tabledata: any = []
    res.data.forEach((item: any) => (
      tabledata = tabledata.concat(item.deliveryBoxDetailList)
    ))
    boxDetail.value = tabledata
  }).finally(() => { })
}

// SKU
const realProductColumns = reactive({ value: productColumns })
watch(() => orderInfo.value, (val) => {
  if (orderInfo.value.thirdWarehouseType === 1) {
    return
  }
  const data = [...productColumns]
  data.forEach((item: Column, index) => {
    if (item.prop === 'skuFile') {
      if (orderInfo.value.thirdWarehouseType !== 0) {
        item.label = t(thirdWarehouseTypeDict[orderInfo.value.thirdWarehouseType] + 'SKU')
      } else {
        // toFix:咋能改column呢
        // item.label = t('客户SKU')
        // item.prop = 'customerProductMsku'
        // item.slotName = ''
        data.splice(index, 1)
      }
    }
  })
  realProductColumns.value = data
})

// 上传文件
const upload = ref(null)
const uploadSku = (event: any, row: any, rowIndex: any) => {
  console.log(event)
  if (!event.length) {
    return
  }
  const params = {
    barCodeName: event[event.length - 1]?.name,
    barCodeUrl: event[event.length - 1]?.raw.url,
    deliveryTaskCode: row.deliveryTaskCode,
    deliveryTaskDetailId: row.deliveryTaskDetailId
  }
  editBarCode(params).then((res: any) => {
    if (res.success) {
      row.barCodeName = event[event.length - 1]?.name
      row.barCodeUrl = event[event.length - 1]?.raw.url
      ElMessage.success(t('上传成功'))
    }
  })
}

const downloadLoading = ref(false)
/** 导出商品标签pdf */
const exportGoodstagPdf = () => {
  const hasNoData = !taskDetailList.value?.length
  const isHasTag = taskDetailList.value?.some((item) => item.tagContent)
  //   如果没有商品数据，或者商品数据里面没有标签
  if (hasNoData || !isHasTag) {
    ElMessage.warning(t('无法导出，至少有一个商品标签'))
    return
  }
  const params:any = []
  taskDetailList.value.forEach((item) => {
    const isHasTagContent = item.tagContent
    // 只有有标签的再导出
    if (isHasTagContent) {
      params.push({ type: 4, shopProductSku: item.shopProductSku })
    }
  })
  downloadLoading.value = true
  axios({
    method: 'post',
    url: process.env.VUE_APP_URL + '/order/shop/product/sku/batchExportTagPdf',
    data: params,
    responseType: 'blob',
    headers: {
      'X-AuthToken': store.getters.token,
      'X-GRAY-TAG': process.env.VUE_APP_X_GRAY_TAG || '',
      'X-AuthShopId': store.getters.curShop,
      'X-Platform': 'PC',
      'X-Appname': 'ckb-client-pc'
    }
  }).then((res: any) => {
    // 若是数据不存在
    if (!res.data.size) {
      ElMessage.warning(t('无法导出，至少有一个商品标签'))
      return
    }
    exportFileDownload(res, { type: 'application/pdf', name: t('国際配送商品のラベルデータ') })
  }).finally(() => { downloadLoading.value = false })
}

const feeDetailVisible = ref(false)
const openDetail = () => {
  feeDetailVisible.value = true
}
const totalAmount: any = ref('-')
// 弹窗返回总额
const backAmountFn = (amount: any) => {
  totalAmount.value = amount
}
const exportLoading = ref(false)
const exportPdf = (documentHeader?: string) => {
  if (exportLoading.value) return
  exportLoading.value = true
  // TODO
  axios({
    method: 'GET',
    url: process.env.VUE_APP_URL + '/settlement/wallet/fund/flow/exportQingQiuShu',
    responseType: 'blob',
    headers: {
      'X-AuthShopId': store.getters.curShop,
      'X-AuthToken': store.getters.token,
      'X-GRAY-TAG': process.env.VUE_APP_X_GRAY_TAG || '',
      'X-Platform': 'PC',
      'X-Appname': 'ckb-client-pc'
    },
    params: {
      platformOrderNo: orderInfo.value.deliveryTaskCode,
      documentHeader
    }
  }).then(res => {
    exportFileDownload(res, { type: 'application/pdf', name: t('领收书') })
  }).finally(() => {
    exportLoading.value = false
  })
}

const modalFundFlowContentRef = ref<InstanceType<typeof ModalFundFlowContent>>()

const downloadPDF = async () => {
  if (!isJA()) {
    exportPdf()
    return
  }
  const res = await getSignUpValue()
  const lastUseData = responseReceiptData(res)
  if (lastUseData.askEveryTime === ASK_ENUM.NO_ASK) {
    exportPdf(lastUseData.content)
    return
  }
  modalFundFlowContentRef.value?.open(lastUseData.content, (value: string) => {
    exportPdf(value)
  })
}
const currentUnit = computed(() => showCurrentUnit(orderInfo.value?.deliveryCountry === COUNTRY.KR))

return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('基本详情')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", null, _toDisplayString(_unref(t)('国际发货单号')) + "： " + _toDisplayString(orderInfo.value?.deliveryTaskCode), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(t)('发货类型')) + "： " + _toDisplayString(_unref(thirdWarehouseTypeDict)[orderInfo.value?.thirdWarehouseType]), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(t)('国际发货状态')) + "： " + _toDisplayString(_unref(deliveryStatusDict)[orderInfo.value?.deliveryStatus]), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(t)('计费重量')) + "： " + _toDisplayString(orderInfo.value?.totalWeight ? (orderInfo.value.totalWeight / 1000) : '-') + " KG ", 1),
        _createElementVNode("p", null, _toDisplayString(_unref(t)('创建时间')) + ": " + _toDisplayString(_unref(getJapanTime)(orderInfo.value?.createTime)), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", null, _toDisplayString(_unref(t)('清关地址')) + "： " + _toDisplayString(clearanceAddressList.value?.name) + " " + _toDisplayString(clearanceAddressList.value?.mobile) + " " + _toDisplayString(clearanceAddressList.value?.nation) + " " + _toDisplayString(clearanceAddressList.value?.province) + " " + _toDisplayString(clearanceAddressList.value?.city) + " " + _toDisplayString(clearanceAddressList.value?.address), 1),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_unref(t)('收货仓/地址')) + "： ", 1),
          (!orderInfo.value?.deliveryType)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(taskDetailList.value?.[0].receiveHouse), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(shippingAddressList.value?.name) + " " + _toDisplayString(shippingAddressList.value?.mobile) + " " + _toDisplayString(shippingAddressList.value?.nation) + " " + _toDisplayString(shippingAddressList.value?.province) + " " + _toDisplayString(shippingAddressList.value?.city) + " " + _toDisplayString(shippingAddressList.value?.address), 1)
              ], 64))
        ]),
        (!!orderInfo.value.extendDTO)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('关税收取方式')) + "： ", 1),
              (orderInfo.value.extendDTO.tariffType === 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(t)('请求书请求')), 1))
                : _createCommentVNode("", true),
              (orderInfo.value.extendDTO.tariffType === 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(t)('账号扣税')), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_el_popover, {
                placement: "right",
                content: "rewfewf",
                trigger: "click",
                width: 300,
                "hide-after": 50,
                offset: 0
              }, _createSlots({
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('金融机构代码')) + "：", 1),
                        _createElementVNode("div", _hoisted_12, _toDisplayString(orderInfo.value.extendDTO.financialInstitutionCode || '-'), 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)('分行代码')) + "：", 1),
                        _createElementVNode("div", _hoisted_15, _toDisplayString(orderInfo.value.extendDTO.branchCode || '-'), 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('账号_关税')) + "：", 1),
                        _createElementVNode("div", _hoisted_18, _toDisplayString(orderInfo.value.extendDTO.taxDeductionAccount || '-'), 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(t)('进口商标准代码')) + "：", 1),
                        _createElementVNode("div", _hoisted_21, _toDisplayString(orderInfo.value.extendDTO.importerCode || '-'), 1)
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, [
                (orderInfo.value.extendDTO.tariffType === 1)
                  ? {
                      name: "reference",
                      fn: _withCtx(() => [
                        _createElementVNode("span", _hoisted_22, "  " + _toDisplayString(_unref(t)('查看明细')) + " >  ", 1)
                      ])
                    }
                  : undefined
              ]), 1024)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(t)('发货详情')), 1),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("p", null, _toDisplayString(_unref(t)('配送件数')) + "：" + _toDisplayString(orderInfo.value?.deliveryNums), 1),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_unref(t)('箱数')) + "： " + _toDisplayString(orderInfo.value?.totalBox) + " ", 1),
          _createVNode(_component_el_button, {
            onClick: checkDetail,
            disabled: orderInfo.value?.totalBox < 1,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('装箱明细')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_unref(t)('装箱清单2')) + "： ", 1),
          _createVNode(_component_el_button, { onClick: exportList }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('ダウンロード')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createTextVNode(_toDisplayString(_unref(t)('费用明细')) + " ", 1),
      (orderInfo.value?.deliveryStatus === 5)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: downloadPDF,
            class: "fl-r",
            type: "primary",
            style: {"margin-top":"-10px"},
            loading: exportLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('领收书下载')), 1)
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createVNode(_component_el_table, {
        data: logisticsDetailList.value,
        "span-method": objectSpanMethod,
        style: {"width":"100%","margin-top":"20px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "logisticsCode",
            label: _unref(t)('国际运费号')
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_button, {
                type: "text",
                loading: row.trackLoading,
                onClick: ($event: any) => (showTrack(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.logisticsCode), 1)
                ]),
                _: 2
              }, 1032, ["loading", "onClick"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _unref(t)('运输方式')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(orderInfo.value?.wmsDistribution), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "freightFee",
            label: _unref(t)('国际运费')
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString((row?.freightFee || 0) + (row?.remoteAreaFee || 0)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _unref(t)('发货附加项'),
            width: 300
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(t)('费用合计')) + "：" + _toDisplayString(orderInfo.value?.additionalFee) + _toDisplayString(_unref(currentUnit)), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((orderInfo.value?.deliveryTaskAdditionalDetailList || []), (v) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: v.additionId,
                  class: "deliver-addition"
                }, [
                  _createElementVNode("div", _hoisted_29, _toDisplayString(v.additionNameJp), 1),
                  _createElementVNode("div", _hoisted_30, [
                    (v.calculateConfigId === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _createTextVNode(_toDisplayString(_unref(t)('单价')) + "：" + _toDisplayString(v.cost) + _toDisplayString(_unref(currentUnit)) + "/", 1),
                          _createElementVNode("sub", null, _toDisplayString(_unref(t)("件")), 1),
                          _hoisted_32,
                          _createElementVNode("span", null, _toDisplayString(_unref(t)('数量')) + "：" + _toDisplayString(v.operand) + "，", 1),
                          _createElementVNode("span", null, _toDisplayString(_unref(t)('合计2')) + "：" + _toDisplayString(v.operand * v.cost) + _toDisplayString(_unref(currentUnit)), 1)
                        ]))
                      : (v.calculateConfigId === 3)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _createTextVNode(_toDisplayString(_unref(t)('单价')) + "：" + _toDisplayString(_unref(t)("商品总金额")) + " " + _toDisplayString(v.cost) + "%， ", 1),
                            _createElementVNode("span", null, _toDisplayString(_unref(t)('数量')) + "：1，", 1),
                            _createElementVNode("span", null, _toDisplayString(_unref(t)('合计2')) + "：" + _toDisplayString(totalGoodsPrice.value * v.cost / 100) + _toDisplayString(_unref(currentUnit)), 1)
                          ]))
                        : (v.calculateConfigId === 5)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              _createTextVNode(_toDisplayString(_unref(t)('单价')) + "：" + _toDisplayString(v.cost) + _toDisplayString(_unref(currentUnit)) + "/", 1),
                              _createElementVNode("sub", null, _toDisplayString(_unref(t)("发货单")), 1),
                              _hoisted_35,
                              _createElementVNode("span", null, _toDisplayString(_unref(t)('数量')) + "：" + _toDisplayString(v.operand) + "，", 1),
                              _createElementVNode("span", null, _toDisplayString(_unref(t)('合计2')) + "：" + _toDisplayString(v.operand * v.cost) + _toDisplayString(_unref(currentUnit)), 1)
                            ]))
                          : (v.calculateConfigId === 6)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                _createTextVNode(_toDisplayString(_unref(t)('单价')) + "：" + _toDisplayString(v.cost) + _toDisplayString(_unref(currentUnit)) + "/", 1),
                                _createElementVNode("sub", null, _toDisplayString(_unref(t)("箱")), 1),
                                _hoisted_37,
                                _createElementVNode("span", null, _toDisplayString(_unref(t)('数量')) + "：" + _toDisplayString(v.operand) + "，", 1),
                                _createElementVNode("span", null, _toDisplayString(_unref(t)('合计2')) + "：" + _toDisplayString(v.operand * v.cost) + _toDisplayString(_unref(currentUnit)), 1)
                              ]))
                            : (v.calculateConfigId === 7)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                  _createTextVNode(_toDisplayString(_unref(t)('单价')) + "：" + _toDisplayString(v.cost) + _toDisplayString(_unref(currentUnit)) + "，" + _toDisplayString(_unref(t)('数量')) + "：" + _toDisplayString(v.operand) + "，" + _toDisplayString(_unref(t)('合计2')) + "：" + _toDisplayString(v.cost *
                  v.operand) + _toDisplayString(_unref(currentUnit)), 1)
                                ], 64))
                              : (v.calculateConfigId === 10)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                    _createTextVNode(_toDisplayString(_unref(t)('单价')) + "：" + _toDisplayString(v.cost) + _toDisplayString(_unref(currentUnit)) + "，" + _toDisplayString(_unref(t)('数量')) + "：" + _toDisplayString(v.operand) + "，" + _toDisplayString(_unref(t)('合计2')) + "：" + _toDisplayString(Number(v.cost * v.operand).toFixed(2)) + _toDisplayString(_unref(currentUnit)), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                    _createTextVNode(_toDisplayString(_unref(t)('单价')) + "：" + _toDisplayString(v.cost) + _toDisplayString(_unref(currentUnit)) + "，" + _toDisplayString(_unref(t)('数量')) + "：1，" + _toDisplayString(_unref(t)('合计2')) + "：" + _toDisplayString(v.cost) + _toDisplayString(_unref(currentUnit)), 1)
                                  ], 64))
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _unref(t)('国际发货合计额')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(totalAmount.value) + _toDisplayString(_unref(currentUnit)) + " ", 1),
              _createElementVNode("a", { onClick: openDetail }, _toDisplayString(_unref(t)('详情')), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, _toDisplayString(_unref(t)('商品内容')), 1),
      (_unref(isJA)() && String(orderInfo.value?.thirdWarehouseType)==='4')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            loading: downloadLoading.value,
            class: "btn-action",
            onClick: exportGoodstagPdf
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("导出商品标签PDF")), 1)
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_40, [
      _createVNode(STable, {
        "row-key": "id",
        tableData: getTaskDetailList(),
        columns: isAmazon.value ? _unref(AmazonColumns) : _unref(realProductColumns).value,
        tableRowClassName: getRowClassName,
        showPagination: false
      }, {
        amazonProductTitle: _withCtx(({ row }) => [
          _createVNode(_component_el_tooltip, {
            effect: "light",
            placement: "top"
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_41, _toDisplayString(row.amazonProductTitle), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_42, _toDisplayString(row.amazonProductTitle), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        productImg: _withCtx(({ row }) => [
          (_unref(isJA)() && row.clientIsTotal)
            ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_unref(t)('合计：')), 1))
            : (_openBlock(), _createBlock(ShoppingPreview, {
                key: 1,
                image: row.productImg
              }, null, 8, ["image"]))
        ]),
        productSkuInfo: _withCtx(({ row }) => [
          _createElementVNode("p", null, _toDisplayString(row.productSku), 1),
          _createElementVNode("p", null, _toDisplayString(row.productName), 1)
        ]),
        skuFile: _withCtx(({ row, rowIndex }) => [
          (row.barCodeUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _createVNode(UploadFileReplace, {
                  file: [{ name: row.barCodeName, url: row.barCodeUrl }],
                  onChange: ($event: any) => (uploadSku($event, row, rowIndex)),
                  ref: (_value, _refs) => {
                    _refs['upload'] = _value
                    upload.value = _value
                  }
                }, null, 8, ["file", "onChange"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_45, "-"))
        ]),
        deliveryNums: _withCtx(({ row }) => [
          (_unref(isJA)() && row.clientIsTotal)
            ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(row.allClientDeliveryNums), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(row.deliveryNums), 1))
        ]),
        realDeliveryNums: _withCtx(({ row }) => [
          (_unref(isJA)() && row.clientIsTotal)
            ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(row.allClientRealDeliveryNums), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(row.realDeliveryNums), 1))
        ]),
        allPrice: _withCtx(({ row }) => [
          (_unref(isJA)() && row.clientIsTotal)
            ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(row.allClientAllPrice), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_unref(round)(((row?.realDeliveryNums ?? 0) * (row?.productPrice ?? 0)) * 100) / 100) + _toDisplayString(_unref(currentUnit)), 1))
        ]),
        amazonFnsku: _withCtx(({ row }) => [
          (_unref(isJA)() && row.clientIsTotal)
            ? (_openBlock(), _createElementBlock("span", _hoisted_52))
            : (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(row.thirdProductSku || '-') + _toDisplayString(row.amazonFnsku ?`(${row.amazonFnsku})` : ''), 1))
        ]),
        customerProductMsku: _withCtx(({ row }) => [
          _createElementVNode("p", null, _toDisplayString(row.customerProductMsku || '-'), 1)
        ]),
        productPrice: _withCtx(({ row }) => [
          (_unref(isJA)() && row.clientIsTotal)
            ? (_openBlock(), _createElementBlock("span", _hoisted_54))
            : (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(row.productPrice) + " " + _toDisplayString(_unref(currentUnit)), 1))
        ]),
        _: 1
      }, 8, ["tableData", "columns"])
    ]),
    _createElementVNode("div", _hoisted_56, _toDisplayString(_unref(t)('箱规')), 1),
    _createElementVNode("div", _hoisted_57, [
      _createVNode(STable, {
        "row-key": "id",
        tableData: boxInfoList.value,
        columns: _unref(boxColumns),
        showPagination: false
      }, {
        boxName: _withCtx(({ rowIndex }) => [
          _createElementVNode("div", null, _toDisplayString(_unref(t)('$箱子$2')) + _toDisplayString(rowIndex + 1), 1)
        ]),
        weight: _withCtx(({ row }) => [
          _createElementVNode("div", null, _toDisplayString((row.weight / 1000)), 1)
        ]),
        _: 1
      }, 8, ["tableData", "columns"])
    ]),
    _createVNode(TrackDialog, {
      visible: trackVisible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((trackVisible).value = $event)),
      rowItem: rowItem.value,
      onRefresh: _ctx.refreshTable
    }, null, 8, ["visible", "rowItem", "onRefresh"]),
    _createVNode(BoxInfoDialog, {
      visible: detailVisible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((detailVisible).value = $event)),
      boxdetail: boxDetail.value,
      boxdetailcolumns: _unref(boxDetailColumns),
      onDownload: exportList
    }, null, 8, ["visible", "boxdetail", "boxdetailcolumns"]),
    _createVNode(ModalFundFlowContent, {
      ref: (_value, _refs) => {
        _refs['modalFundFlowContentRef'] = _value
        modalFundFlowContentRef.value = _value
      }
    }, null, 512),
    _createVNode(FeeDetail, {
      visible: feeDetailVisible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((feeDetailVisible).value = $event)),
      deliverOrderNo: orderInfo.value.deliveryTaskCode,
      currentUnit: _unref(tCurrency)('CNY', orderInfo.value?.deliveryCountry)?.trim(),
      countryCode: orderInfo.value?.deliveryCountry,
      onBackAmount: backAmountFn
    }, null, 8, ["visible", "deliverOrderNo", "currentUnit", "countryCode"])
  ]))
}
}

})